var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"door-modal-header"},[_c('p',[_vm._v(_vm._s(_vm.modalHeader))])]),_c('div',{staticClass:"door-modal-content"},[(_vm.actionType == _vm.actions.open_door)?_c('p',{domProps:{"innerHTML":_vm._s(
        _vm.$t('sitesAndDevices.kioskActions.openDoorConfirm', {
          kiosk: _vm.kioskInfo.kiosk_name,
        })
      )}}):(_vm.actionType == _vm.actions.restart_app)?_c('p',{domProps:{"innerHTML":_vm._s(
        _vm.$t('sitesAndDevices.kioskActions.restartAppConfirm', {
          kiosk: _vm.kioskInfo.kiosk_name,
        })
      )}}):(_vm.actionType == _vm.actions.restart_kiosk)?_c('p',{domProps:{"innerHTML":_vm._s(
        _vm.$t('sitesAndDevices.kioskActions.restartKioskConfirm', {
          kiosk: _vm.kioskInfo.kiosk_name,
        })
      )}}):_vm._e()]),_c('hr',{staticClass:"separate-line"}),_c('div',{staticClass:"door-modal-footer"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('button',{staticClass:"btn-action btn-action-open",on:{"click":function($event){return _vm.submitAction()}}},[_vm._v(" "+_vm._s(_vm.btnValue)+" ")]),_c('button',{staticClass:"btn-action btn-action-cancel",on:{"click":function($event){return _vm.$bvModal.hide('kioskActions' + _vm.kioskInfo.mac_address)}}},[_vm._v(" "+_vm._s(_vm.$t("common.cancel"))+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }